import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

import { LanguageProvider, initialStateEnglish, initialStateFrench } from './contexts/LanguageProvider';
import { AppStateProvider, initialState } from './contexts/AppStateProvider';

const defaultNetwork = document.getElementById('root').getAttribute('data-network');

ReactDOM.render(
  <React.StrictMode>
    <LanguageProvider initialState={(document.documentElement.lang === 'fr') ? initialStateFrench : initialStateEnglish}>
      <AppStateProvider initialState={initialState}>
        <App defaultNetwork={defaultNetwork} />
      </AppStateProvider>
    </LanguageProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
